// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SpeakerVolumeOffIconSignature {
  Element: SVGSVGElement;
}

export const SpeakerVolumeOffIcon: TOC<SpeakerVolumeOffIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.025 11V14.732L5.49 16.268C5.204 15.921 5.025 15.483 5.025 15V11C5.025 9.898 5.922 9 7.025 9H9.504L12.611 4.586C13.174 4.021 14.05 3.846 14.789 4.152C15.466 4.431 15.906 5.053 15.99 5.767L14.025 7.732V6.027L10.546 11H7.025ZM21.707 5.707L20.293 4.293L3.293 21.293L4.707 22.707L9.879 17.536L12.499 21.281C12.916 21.777 13.458 22.001 14.025 22.001C14.288 22.001 14.546 21.95 14.789 21.85C15.54 21.54 16.025 20.813 16.025 20.001V11.39L21.707 5.707ZM14.027 19.976L11.316 16.099L14.027 13.388V19.976Z"/>
</svg>
</template>;